import {AfterViewInit, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import {Question} from '../../models/underwriter.model';
import {newGuid} from '../question-helper';
import {QuestionType} from '../../constants';
import {GlobalQuestionService} from '../../services/global-question.service';
import {Subject} from 'rxjs';
import {debounceTime} from 'rxjs/operators';
import { Alert } from '../../utilities';


@Component({
    selector: 'app-question-label-textbox-parent',
    templateUrl: './question-label-textbox-parent.component.html',
    styleUrls: ['./question-label-textbox-parent.component.scss'],
    standalone: false
})
export class QuestionLabelTextboxParentComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {

  @Input() question: Question;
  @Input() showHeader = true;
  @Input() showHeaderTotal = false;
  @Input() showFooterTotal = false;
  @Input() showDelete = false;
  @Input() isPercentage = false;
  @Input() showParent = true;
   @Input() isEditModal = true;
  @Input() itemQuestions: Question[] = [];
  @Output() questionAnswer = new EventEmitter<any>();
  @Output() parentQuestionAnswer = new EventEmitter();

  childrenQuestions: Question[] = [];
  uniqueId = `label-textbox-parent-${newGuid()}`;
  QuestionType = QuestionType;
  total = 0;
  questionChanged = new Subject<Question>();
  parameters: any[] = [];
  total100 = true;
  validateTotal = 0;
  constructor(private questionService: GlobalQuestionService) {
  }

  ngOnInit(): void {
    this.questionChanged.pipe(
      debounceTime(500)
    ).subscribe(x => {
      if (x) {
        this.saveAnswer(x);
      }
    });
    
    
  }

  ngAfterViewInit(): void {
    
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.question?.currentValue) {
      this.question = changes?.question?.currentValue;
      
      if (this.question?.parameter) {
        this.parameters = JSON.parse(this.question?.parameter);
       
        if (this.parameters?.length) {
          
          if (this.parameters.find(p => p.parameter === 'showtotal')?.value == 1) {
            if (this.parameters.find(p => p.parameter === 'position')?.value == 1) {
              this.showHeaderTotal = true;
            } else {
              this.showFooterTotal = true;
            }
          }
          if (this.parameters.find(p => p.parameter === 'showheader')?.value == 0){
            this.showHeader = false;
          }
          if (this.parameters.some(p => p.parameter === 'total100')){
            this.total100 = false;
          }
           if (this.parameters.find(p => p.parameter === 'validate_total')){
            this.validateTotal = this.parameters.find(p => p.parameter === 'validate_total')?.value;
          }
        }
        
      }
      if (this.question) {
        this.childrenQuestions = [];
        if (this.itemQuestions?.length) {
          this.childrenQuestions = this.itemQuestions;
          for (const q of this.childrenQuestions) {
            if (q?.answer?.includes('|')) {
              this.total += +q.answer.split('|')[1];
            } else {
              this.total += +q.answer;
            }
          }
        } else {
          this.getChildrenQuestion();
        }
        
      }
    }
    //this.total = 0;
  }

  getChildrenQuestion(): void {
    this.questionService.spinner(true);
    this.questionService.getChildrenQuestions(this.question?.cent_aq_question_id)
      .subscribe((items: Question[]) => {
        
        this.childrenQuestions = [];
        if (items.length > 0) {
          if (items.every(q => q.answer === '') && items.length > 1) {
            
            // Create a new object with the modified answer
            this.childrenQuestions = items.map((q, index) => {
              if (index === 0 && this.isPercentage) {
                return { ...q, answer: '100' };
              }
              else {
                return { ...q, answer: '0'};
              }
            });
          }
          else {
            for (const q of items) {
              if (!this.childrenQuestions.some(c => c.cent_aq_question_id === q.cent_aq_question_id)) {
                this.childrenQuestions.push(Object.assign({}, q));
              }
            }
          }
        }
        this.onChange(this.childrenQuestions[0], 0);
        console.log('this.childrenQuestions', this.childrenQuestions);
        if (this.showFooterTotal) {
          setTimeout(() => {
           this.performChecks();
          }, 1000);
        }
        this.questionService.spinner(false);
        
      });

  }
 performChecks(): void {
   this.total = 0;
   for (const q of this.childrenQuestions) {
     if (q?.answer?.includes('|')) {
       this.total += +q.answer.split('|')[1];
     } else {
       this.total += +q.answer;
     }
   }
    
   if (this.childrenQuestions.every(q => q.answer)) {
     if (this.isPercentage && !this.total100) {
       this.question.answer = 'Multiple answers';
       this.questionAnswer.emit(this.question);
     }
     else if (this.isPercentage && this.total === 100) {
       this.question.answer = 'Multiple answers';
       this.questionAnswer.emit(this.question);
     } else if (this.isPercentage && this.total > 100) {
       this.question.answer = null;
       this.questionAnswer.emit(this.question);
     } else if (!this.isPercentage) {
       if (this.validateTotal && this.total <= +this.validateTotal) {
         this.question.answer = null;
         this.questionAnswer.emit(this.question);
       } else {
         this.question.answer = 'Multiple answers';
         this.parentQuestionAnswer.emit(this.childrenQuestions);
         this.questionAnswer.emit(this.question);
       }
     }
     if (this.isEditModal) {
       this.questionService.saveAnswersOnly(this.childrenQuestions);
     }
   }
 }
  onChange(value: Question, index: number): void {
    this.performChecks();
  }

  saveAnswer(question: Question): void {
    this.questionService.saveAnswerOnly(question).subscribe();
  }

  ngOnDestroy(): void {
    this.questionChanged.next(undefined as any);
    this.questionChanged.complete();
    this.childrenQuestions = [];
  }

}
